<template>
	<div id="home-Body">
		<!-- home-head-->
		<div id="home-head">
			<img src="./../../mycomponents/img/logo/LOGO.svg" alt="" />
			<p>{{ $t("fastcompression") }}</p>
			<p></p>
			<p v-show="!$app.language">{{ $t("lighteasytouse") }} {{ $t("startagain") }}</p>
			<p>V3.9.4</p>
		</div>
		<!-- home-section -->
		<div id="home-section">
			<router-link
				class="home-section-divFirst"
				:class="{
					'home-section-divFirst_Full-secreen': $app.isFullScreen && $app.nowSeceen.width >= 1680,
					'home-section-divFirst_en': $app.language,
				}"
				to="/main/tpys"
			>
				<img src="./../../mycomponents/img/home/pic_tupianyasuo_132＊132@2x.png" alt="" />
				<div>
					<p>{{ $t("picturecompression") }}</p>
					<p>{{ $t("supportjpgpnggifbmpformats") }}</p>
				</div>
			</router-link>
			<router-link
				class="home-section-divFirst"
				:class="{
					'home-section-divFirst_Full-secreen': $app.isFullScreen && $app.nowSeceen.width >= 1680,
					'home-section-divFirst_en': $app.language,
				}"
				to="/main/spys"
			>
				<img src="./../../mycomponents/img/home/pic_shipyasuo_132＊132@2x.png" alt="" />
				<div>
					<p>{{ $t("videocompression") }}</p>
					<p>{{ $t("text032") }}</p>
				</div>
			</router-link>
			<router-link
				class="home-section-divFirst"
				:class="{
					'home-section-divFirst_Full-secreen': $app.isFullScreen && $app.nowSeceen.width >= 1680,
					'home-section-divFirst_en': $app.language,
				}"
				to="/main/pdfys"
			>
				<img src="./../../mycomponents/img/home/pic_pdfyauso_132＊132@2x.png" alt="" />
				<div>
					<p>PDF {{ $t("compress") }}</p>
					<p>{{ $t("text029") }}</p>
				</div>
			</router-link>
			<router-link
				class="home-section-divFirst"
				:class="{
					'home-section-divFirst_Full-secreen': $app.isFullScreen && $app.nowSeceen.width >= 1680,
					'home-section-divFirst_en': $app.language,
				}"
				to="/main/wordys"
			>
				<img src="./../../mycomponents/img/home/pic_word_132＊132@2x.png" alt="" />
				<div>
					<p>Word {{ $t("compress") }}</p>
					<p>{{ $t("text033") }}</p>
				</div>
			</router-link>
			<router-link
				class="home-section-divFirst"
				:class="{
					'home-section-divFirst_Full-secreen': $app.isFullScreen && $app.nowSeceen.width >= 1680,
					'home-section-divFirst_en': $app.language,
				}"
				to="/main/pptys"
			>
				<img src="./../../mycomponents/img/home/pic_pptyauso_132＊132@2x.png" alt="" />
				<div>
					<p>PPT {{ $t("compress") }}</p>
					<p>{{ $t("documentslimminghighdefinition") }}</p>
				</div>
			</router-link>
		</div>
		<!-- home-footer -->
		<div id="home-footer" v-if="!$app.language">
			<p>{{ $t("featuredproductrecommendation") }}</p>
			<div id="home-footer-div">
				<div class="home-footer-div-all">
					<a
						href="https://www.xunjiepdf.com/converter"
						@click="gevt('首页特色产品推荐', '点击事件', '迅捷PDF转换器', 'None', 'None', 'None')"
						target="_blank"
					>
						<img src="./../../mycomponents/img/home/icon tj pdf.svg" alt="" /><span>{{
							$t("fastpdfconverter")
						}}</span>
					</a>
				</div>
				<div class="home-footer-div-all">
					<a
						href="https://www.xunjiepdf.com/editor"
						@click="gevt('首页特色产品推荐', '点击事件', '迅捷PDF编辑器', 'None', 'None', 'None')"
						target="_blank"
					>
						<img src="./../../mycomponents/img/home/icon_tj_pdfbj.svg" alt="" /><span>{{
							$t("fastpdfeditor")
						}}</span>
					</a>
				</div>
				<div class="home-footer-div-all">
					<a
						href="https://www.xunjiepdf.com/ocr"
						@click="
							gevt('首页特色产品推荐', '点击事件', '迅捷OCR文字识别软件', 'None', 'None', 'None')
						"
						target="_blank"
					>
						<img src="./../../mycomponents/img/home/icon tj ocr.svg" alt="" /><span>{{
							$t("text035")
						}}</span>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import gevt from "../../plugins/gevt";
/**首页 */
export default {
	name: "Home",
	data() {
		return {};
	},
	methods: {
		// 功能方块点击跳转至相应的模块
		homeSectionRouter(str) {
			this.$router.push({path: "/main", query: {name: str}});
		},
		gevt(a, b, c, d, e, f) {
			gevt(a, b, c, d, e, d);
		},
	},
	watch: {
		$route(to, from) {},
	},
	components: {},
	mounted() {},
	activated() {
		console.log("home activated");
		gevt("页面浏览", "视图事件", "首页", "None", this.$app.VIPState, "None");
	},
};
</script>
<style lang="less" scoped>
#home-Body {
	/* padding: 50rem; */
	/* box-sizing: border-box; */
	/* height: calc(100% - 100rem); */
	height: 100%;
	width: 100%;
	/* position: relative; */
}

/* home-head */
#home-head {
	/* position: absolute; */
	/* top: 0rem; */
	height: 48rem;
	padding-left: 40rem;
	padding-top: 17rem;
}
#home-head * {
	display: inline-block;
	vertical-align: middle;
}
#home-head img {
	width: 48rem;
	height: 48rem;
	margin-right: 5rem;
}
#home-head p span {
	vertical-align: middle;
}
#home-head p:nth-of-type(1) {
	font-size: 24rem;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #1b212e;
	/* letter-spacing: 10rem; */
	opacity: 1;
	margin-right: 9rem;
}
#home-head p:nth-of-type(2) {
	width: 0rem;
	height: 24rem;
	border-left: 1rem solid #5c7099;
	/* border: ; */
	opacity: 1;
	margin-right: 8rem;
	margin-top: 5rem;
}
#home-head p:nth-of-type(3) {
	font-size: 24rem;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #5c7099;
	/* letter-spacing: 10rem; */
	opacity: 1;
	margin-top: 2rem;
	margin-right: 8rem;
}
#home-head p:nth-of-type(4) {
	font-size: 14rem;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #5c7099;
	/* letter-spacing: 10rem; */
	margin-top: 6rem;
	opacity: 1;
}

#home-head::after {
	content: "";
	display: inline-block;
	height: 100%;
	vertical-align: middle;
}
/* home-section */
#home-section {
	width: 100%;
	height: calc(100% - 131rem);
	padding-left: 40rem;
	/* padding-right: 40rem; */
	padding-top: 39rem;
	box-sizing: border-box;
}

.home-section-divFirst {
	width: 29.8%;
	height: 37.54%;
	background: #ffffff;
	opacity: 1;
	border-radius: 8rem;
	margin-right: 3.5%;
	margin-bottom: 3.5%;
	display: inline-block;
	cursor: pointer;
}

.home-section-divFirst:hover {
	box-shadow: 0rem 10rem 20rem -4rem rgba(103, 168, 221, 0.212),
		0rem 5rem 20rem -4rem rgba(103, 168, 221, 0.212);
	transition: all 0.3s;
}
.home-section-divFirst::after {
	content: "";
	display: inline-block;
	vertical-align: middle;
	height: 100%;
}

.home-section-divFirst img {
	width: 38.82%;
	height: 67.34%;
	display: inline-block;
	vertical-align: middle;
}
.home-section-divFirst div {
	display: inline-block;
	vertical-align: middle;
}
.home-section-divFirst div P:nth-of-type(1) {
	/* width: 121rem; */
	height: 44rem;
	font-size: 30rem;
	font-family: Source Han Sans CN;
	font-weight: bold;
	/* line-height: 18rem; */
	color: #364159;
	/* letter-spacing: 10rem; */
	opacity: 1;
	margin-bottom: 8rem;
}
.home-section-divFirst div p:nth-of-type(2) {
	/* width: 178rem; */
	height: 20rem;
	font-size: 14rem;
	font-family: Source Han Sans CN;
	font-weight: 400;
	/* line-height: 18rem; */
	color: #5c7099;
	/* letter-spacing: 10rem; */
	opacity: 1;
}

/* home-footer */
#home-footer {
	/* position: absolute; */
	/* bottom: 50rem; */
	height: 26rem;
	padding-left: 40rem;
	padding-bottom: 40rem;
}
#home-footer ::after {
	content: "";
	height: 100%;
	display: inline-block;
	vertical-align: middle;
}
#home-footer p:nth-of-type(1) {
	vertical-align: middle;
	display: inline-block;
	height: 26rem;
	width: 127rem;
	font-size: 18rem;
	font-family: Source Han Sans CN;
	font-weight: bold;
	/* line-height: 18rem; */
	color: #364159;
	/* letter-spacing: 10rem; */
	opacity: 1;
	margin-right: 26rem;
}
#home-footer-div {
	height: 26rem;
	display: inline-block;
	vertical-align: middle;
	/* margin-top: 20rem; */
	/* margin-bottom: 10rem; */
	/* margin-right: 50rem; */
}
#home-footer-div ::after {
	content: "";
	height: 100%;
	display: inline-block;
	vertical-align: middle;
}
.home-footer-div-all {
	display: inline-block;
	vertical-align: middle;
	cursor: pointer;
	margin-right: 34rem;
}
.home-footer-div-all a {
	text-decoration: none;
}
/* .home-footer-div-all:hover {
	background-color: #e9f1fd;
	border-radius: 5rem;
} */
.home-footer-div-all::after {
	content: "";
	display: inline-block;
	height: 100%;
	vertical-align: middle;
}
.home-footer-div-all img {
	margin-right: 5rem;
	height: 22rem;
	width: 22rem;
	vertical-align: middle;
	margin-right: 6rem;
	border-radius: 4rem;
}
.home-footer-div-all span {
	vertical-align: middle;
	/* width: 125rem; */
	height: 26rem;
	font-size: 18rem;
	font-family: Source Han Sans CN;
	font-weight: 400;
	/* line-height: 18rem; */
	color: #5c7099;
	/* letter-spacing: 10rem; */
	opacity: 1;
}

/* 响应式 */

.home-section-divFirst_Full-secreen div P:nth-of-type(1) {
	/* width: 121rem; */
	/* width: 193rem; */
	height: 70rem;
	font-size: 48rem;
	font-family: Source Han Sans CN;
	font-weight: bold;
	/* line-height: 29rem; */
	color: #364159;
	/* letter-spacing: 10rem; */
	opacity: 1;
	margin-bottom: 8rem;
}
.home-section-divFirst_Full-secreen div p:nth-of-type(2) {
	/* width: 178rem; */
	/* width: 276rem; */
	height: 32rem;
	font-size: 22rem;
	font-family: Source Han Sans CN;
	font-weight: 400;
	/* line-height: 28rem; */
	color: #5c7099;
	opacity: 1;
}

// en英文版样式
.home-section-divFirst_en {
	div {
		p {
			font-family: Arial;
			&:nth-of-type(1) {
				width: 185rem;
				height: auto;
				font-size: 18rem;
			}
			&:nth-of-type(2) {
				width: 195rem;
				font-size: 14rem;
				height: auto;
			}
		}
	}
}
</style>
